import React, { useEffect, useRef } from "react";
import QRCode from "react-qr-code";

import {
  APP_STORE_URL,
  DOWNLOAD_PAGE_URL,
  PLAY_STORE_URL,
} from "../../utils/links";

/**
 * Desktop "Get the app" dialog: a QR code for the phone camera plus direct
 * store links. Closes on Escape, on the backdrop, and on the close button.
 */
function GetAppModal({ open, onClose }) {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeButtonRef.current?.focus();

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="vp-modal-backdrop" onClick={onClose}>
      <div
        className="vp-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="vp-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          ref={closeButtonRef}
          type="button"
          className="vp-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
            <path
              d="M1 1l12 12M13 1L1 13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>

        <h2 id="vp-modal-title" className="vp-modal-title">
          Get Vama on your phone
        </h2>
        <p className="vp-modal-text">
          Point your phone's camera at the code to download the app.
        </p>

        <div className="vp-qr">
          <QRCode value={DOWNLOAD_PAGE_URL} size={176} bgColor="#ffffff" fgColor="#0f1419" />
        </div>

        <div className="vp-store-links">
          <a href={APP_STORE_URL} target="_blank" rel="noreferrer">
            App Store
          </a>
          <span aria-hidden="true">·</span>
          <a href={PLAY_STORE_URL} target="_blank" rel="noreferrer">
            Google Play
          </a>
        </div>
      </div>
    </div>
  );
}

export default GetAppModal;
